<template>
    <main id="realisations">
    <header>
      <div class="title">
        <h1>Réalisation</h1>
      </div>
    </header>
    <article id="someRealisation">
      <h2>Découvrez quelques réalisations</h2>
      <p>
        Chez Industrie ACL, nous concevons, fabriquons et transformons toute
        structure de métal. Depuis notre arrivée sur le marché en 2001, notre
        service à la clientèle exceptionnel et le professionnalisme de toute
        notre équipe ont fait notre renommée et notre crédibilité.
      </p>
    </article>
    <article id="realisation">
      <nav>
        <button v-for="real in realisations" :key="realisations.indexOf(real)" @click="switchReal(real.name)">
          {{ real.title }}
        </button>
      </nav>
      <section v-show="isVisible == real.name" v-for="real in realisations" :key="'real-section' + realisations.indexOf(real)">
        <p>{{ real.text }}</p>
        <Carousel>
          <CarouselSlide v-for="image in real.images" :index="real.images.indexOf(image)" :key="real.images.indexOf(image)">
            <img v-lazy="image">
          </CarouselSlide>
        </Carousel>
      </section>
    </article>
    <div class="gray-bg">
      <article id="estimation">
        <h2>Estimation de coûts pour votre projet?</h2>
        <p>
          N'hésitez pas à communiquer avec un membre de notre équipe pour obtenir
          un estimé de coûts pour vos projets. L'entreprise saura certainement
          répondre rapidement à vos besoins les plus spécifiques.
        </p>
      </article>
    </div>
  </main>
</template>

<script>
import Carousel from '@/components/carousel/Carousel'
import CarouselSlide from '@/components/carousel/CarouselSlide'

export default {
  components: {
    Carousel,
    CarouselSlide
  },
  data () {
    return {
      isVisible: 'Xyz',
      realisations: [
        {
          name: 'Xyz',
          title: 'xyz technologie culturelle',
          text: `Le milieu du divertissement n'est pas un secret pour Industrie ACL.
                L'entreprise collabore depuis longtemps à plusieurs projets de conception
                dédiés à des expositions, des parcours interprétatifs et des musées, avec
                le concepteur de solutions audiovisuelles et scénographiques. XYZ -
                Technologie culturelle se spécialise à faire vivre une expérience aux
                visiteurs dans les expositions, les parcours interprétatifs, les musées,
                les salles de spectacles, les théâtres, les environnements immersifs et
                les installations audiovisuelles diverses (salle de conférence, aréna,
                kiosque, signalisation, éclairage architectural, etc.). Dans le cadre de
                différents projets culturels, l'équipe créative de Industrie ACL a conçu
                divers  présentoirs de musées, des caissons d'éclairage dédiés à un
                nouveau décor au Casino de Montréal. De plus, Industrie ACL collabore
                actuellement à la réalisation d'une structure destinée au Comité Olympique
                Canadien.`,
          images: [
            require('@/assets/images/new-realisations/xyz/gaspe/01.jpg'),
            require('@/assets/images/new-realisations/xyz/gaspe/02.jpg'),
            require('@/assets/images/new-realisations/xyz/gaspe/03.jpg'),
            require('@/assets/images/new-realisations/xyz/gaspe/04.jpg'),
            require('@/assets/images/new-realisations/xyz/gaspe/05.jpg'),
            require('@/assets/images/new-realisations/xyz/gaspe/06.jpg'),
            require('@/assets/images/new-realisations/xyz/city-walk/01.jpg'),
            require('@/assets/images/new-realisations/xyz/city-walk/02.jpg'),
            require('@/assets/images/new-realisations/xyz/city-walk/03.jpg'),
            require('@/assets/images/new-realisations/xyz/city-walk/04.jpg'),
            require('@/assets/images/new-realisations/xyz/city-walk/05.jpg'),
            require('@/assets/images/new-realisations/xyz/geoparc/01.jpg'),
            require('@/assets/images/new-realisations/xyz/geoparc/02.jpg'),
            require('@/assets/images/new-realisations/xyz/geoparc/03.jpg'),
            require('@/assets/images/new-realisations/xyz/geoparc/04.jpg'),
            require('@/assets/images/new-realisations/xyz/geoparc/05.jpg'),
            require('@/assets/images/new-realisations/xyz/lao/01.jpg'),
            require('@/assets/images/new-realisations/xyz/lao/02.jpg'),
            require('@/assets/images/new-realisations/xyz/lao/03.jpg'),
            require('@/assets/images/new-realisations/xyz/lao/04.jpg')
          ]
        }, {
          name: 'PlatsChef',
          title: 'plats du chef',
          text: `Plats du Chef exploite des sites de production à Montréal et à Toronto,
                qui possèdent la certification SQF de niveau 3, décernée pour la qualité
                et la sécurité des aliments. Sa clientèle du créneau des marques privées
                inclut pour sa part des chefs de file de l’alimentation en Amérique du
                Nord. Ses installations à la fine pointe de la technologie offrent d’une
                part une grande variété de technologies brevetées; d’autre part, une
                équipe de l’innovation gère avec efficacité chacune des étapes du
                processus de la commercialisation. À cette équipe innovante se joint
                Industrie ACL pour l'entretien préventif lors des arrêts annuels, la
                modification des machines sur les lieux permettant l'amélioration
                considérable de la productivité et bien sûr, l'usinage de pièces assurant
                le respect des normes strictes du secteur de l'alimentation.`,
          images: [
            require('@/assets/images/new-realisations/plats-du-chef/01.jpg'),
            require('@/assets/images/new-realisations/plats-du-chef/02.jpg')
          ]
        }, {
          name: 'SaladExpress',
          title: 'saladexpress',
          text: `L'entretien et la modification des lignes de production ainsi que
                l'amélioration de la productivité font parties du quotidien de Industrie
                ACl auprès de son client SaladExpress. Dans leurs installations dotées
                d’équipements technologiques de pointe, notre équipe s'assure de respecter
                les règles strictes d'hygiène et des normes alimentaires tout en
                favorisant l'atteinte des objectifs de production ciblés par le client. La
                soudure de l'acier inoxydable, le cintrage tubulaire, le pliage et
                l'usinage conventionnel représentent les services offerts par Industrie
                ACL auprès de ce client.`,
          images: [
            require('@/assets/images/realisations/saladexpress/saladexpress_01.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_02.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_03.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_04.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_05.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_06.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_07.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_08.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_09.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_10.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_11.jpg'),
            require('@/assets/images/realisations/saladexpress/saladexpress_12.jpg')
          ]
        }, {
          name: 'CirqueSoleil',
          title: 'cirque du soleil',
          text: `Depuis plusieurs années, Industrie ACL collabore à la réalisation de
                divers projets de décoration et de conception de structures avec le Cirque
                du Soleil. De la création d'une arche décorative à la fabrication des
                boîtes de transport en acier lors des tournées, notre équipe est fière de
                s'associer à ce joyau domaine du divertissement mondial.`,
          images: [
            require('@/assets/images/realisations/cirquesoleil/kooza_01.jpg'),
            require('@/assets/images/realisations/cirquesoleil/kooza_02.jpg'),
            require('@/assets/images/realisations/cirquesoleil/am_01.jpg'),
            require('@/assets/images/realisations/cirquesoleil/am_02.jpg')
          ]
        }, {
          name: 'PlaisirsGastronomiques',
          title: 'Plaisirs gastronomiques',
          text: `De la conception des produits jusqu’à leur assemblage, dans une usine moderne
                et sécurisante, Plaisirs Gastronomiques s’impose une approche qualitative sans
                compromis. Cette approche laisse toujours une grande place à l’intervention et
                au savoir-faire de l’artisan, leur permettant d’offrir des produits de qualité
                et une expérience maison. La soudure de l'acier inoxydable, le cintrage tubulaire,
                le pliage et l'usinage conventionnel représentent les services offerts par
                Industrie ACL auprès de ce client.`,
          images: [
            require('@/assets/images/new-realisations/plaisirs-gastronomiques/01.jpg'),
            require('@/assets/images/new-realisations/plaisirs-gastronomiques/02.jpg'),
            require('@/assets/images/new-realisations/plaisirs-gastronomiques/03.jpg'),
            require('@/assets/images/new-realisations/plaisirs-gastronomiques2/01.jpg'),
            require('@/assets/images/new-realisations/plaisirs-gastronomiques2/02.jpg'),
            require('@/assets/images/new-realisations/plaisirs-gastronomiques2/03.jpg'),
            require('@/assets/images/new-realisations/plaisirs-gastronomiques2/04.jpg')
          ]
        }, {
          name: 'KiloSysteme',
          title: 'Kilo Système',
          text: `Spécialiste en équipements de pesage et emballage automatiques, Kilo Systeme Inc.
                est le distributeur Daumar et Sorma au Canada pour tout les besoins de pesage et
                d'emballage automatisés de produits.
                Que ce soit pour l’emballage d’oignons, patates, carottes, bettraves, fruits de mer,
                friandises (bonbons, arachides, etc) ou autres, Kilo Systeme Inc. est une compagnie
                qui a toujours su répondre aux exigences du marché et de ces clients en offrant un
                éventail de produits variés à la fine pointe de la technologie.
                La soudure de l'acier inoxydable, le cintrage tubulaire, le pliage et l'usinage
                conventionnel représentent les services offerts par Industrie ACL auprès de ce client.`,
          images: [
            require('@/assets/images/new-realisations/kilo-systeme/01.jpg'),
            require('@/assets/images/new-realisations/kilo-systeme/02.jpg'),
            require('@/assets/images/new-realisations/kilo-systeme/03.jpg'),
            require('@/assets/images/new-realisations/kilo-systeme/04.jpg')
          ]
        }, {
          name: 'AlimentsBercy',
          title: 'Les aliments Bercy',
          text: `Soucieux de proposer à ses clients des aliments sains et savoureux adaptés au mode
                de vie effervescent des gens d’aujourd’hui, Les Aliments Bercy inc. collaborent de près
                avec ses partenaires pour offrir des fruits et légumes respirant la pureté et aussi frais
                que s’ils provenaient de votre jardin.  Le service d’emballage sur mesure limite la
                manipulation des aliments et, par le fait même, réduit grandement le risque de propagation
                de bactéries ou autres indésirables. Industrie ACL a conçu un station d'emballage
                répondant aux besoins spécifiques de ce client.`,
          images: [
            require('@/assets/images/new-realisations/les-aliments-bercy/01.jpg'),
            require('@/assets/images/new-realisations/les-aliments-bercy/02.jpg'),
            require('@/assets/images/new-realisations/les-aliments-bercy/03.jpg')
          ]
        }, {
          name: 'VergersLeahy',
          title: 'Les Vergers Leahy',
          text: `Depuis 1980, Vergers Leahy met tout son savoir-faire pour créer des produits sains,
                gourmands et de qualité. Chaque jour, notre entreprise de classe mondiale transforme en
                moyenne 500,000 livres de fruits et légumes frais destinés aux marchés canadiens,
                américains et d’outre-mer. Industrie ACL offre une produit spécialisé adapté aux
                besoins spécifiques du clieut.`,
          images: [
            require('@/assets/images/new-realisations/les-vergers-leahy/01.jpg'),
            require('@/assets/images/new-realisations/les-vergers-leahy/02.jpg'),
            require('@/assets/images/new-realisations/les-vergers-leahy/03.jpg')
          ]
        }, {
          name: 'Others',
          title: 'autres réalisation',
          text: `Industrie ACL participe à de multiples projets et peut s'adapter aux
                demandes particulières de chaque secteur.`,
          images: [
            require('@/assets/images/realisations/autres/autres_01.jpg'),
            require('@/assets/images/realisations/autres/autres_02.jpg'),
            require('@/assets/images/realisations/autres/autres_03.jpg'),
            require('@/assets/images/realisations/autres/autres_04.jpg'),
            require('@/assets/images/realisations/autres/autres_05.jpg'),
            require('@/assets/images/realisations/autres/autres_06.jpg'),
            require('@/assets/images/realisations/autres/autres_07.jpg'),
            require('@/assets/images/realisations/autres/autres_08.jpg'),
            require('@/assets/images/realisations/autres/autres_09.jpg')
          ]
        }
      ]
    }
  },
  methods: {
    switchReal (name) {
      if (name !== this.isVisible) {
        this.isVisible = name
      }
    }
  }
}
</script>

<style lang="scss">
#realisations {
  header {
    background-image: url(../assets/images/headers/realisation.jpg);
  }
}

img[lazy=loading] {
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RealisationsPage.vue